import { createFileRoute } from "@tanstack/react-router"
import { CompanyOverviewPage } from "@/features/companies/company-overview-page"
export const Route = createFileRoute("/_authenticated/companies/$companyId/")({ component: CompanyOverviewPage })
